export const imageGenerationModels = ['Aeolian 2', 'GPT'] as const;
export type ImageGenerationModel = (typeof imageGenerationModels)[number];

export function isImageGenerationModel(value: unknown): value is ImageGenerationModel {
	return imageGenerationModels.some((model: ImageGenerationModel) => model === value);
}

export function resolveImageGenerationModel(
	urlModel: string | null,
	storedModel: string | null
): ImageGenerationModel {
	const preferredModel: string | null = urlModel ?? storedModel;
	return isImageGenerationModel(preferredModel) ? preferredModel : 'Aeolian 2';
}
